module.exports = __webpack_public_path__ + "static/img/ssing.dd728a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ssing.png
// module id = 0YbO
// module chunks = 0